/**
 * Usable Media Key Status.
 *
 *
 * @beta
 */
export const USABLE = 'usable'
